import React from 'react';
import PropTypes from 'prop-types';

class Contact extends React.Component {
  render() {
    const { firstName, lastName, email, phoneNumber, region } = this.props.contact;

    return (
      <article className="contact__copy">
        <h4 className="contact__name">{`${firstName} ${lastName}`}</h4>
        <p className="contact__info">{region} Region</p>
        <p className="contact__info">
          <a href={`tel:+01-${phoneNumber}`} className="contact__number">
            {phoneNumber}
          </a>
        </p>
        <p className="contact__info">
          <a
            data-cta="Email: Further Information"
            className="contact__email"
            href={`mailto:${email}`}
          >
            {email}
          </a>
        </p>
      </article>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js